import { Base, Input, Span, IBaseComponent } from '@codesuma/baseline'
import style from './index.module.css'

// One row of a list to tick — the settings, the prices to follow: the label at
// the start and, at the end, a checkbox or a radio drawn by the stylesheet in
// the page's own ink. The label is words, or a component of the page's own
// when it has more than words to show. A real
// <input> inside a <label>, kept in the page and out of sight, so a tap
// anywhere along the row still toggles it and the keyboard and screen readers
// get the control they expect — only the paint is ours.
//
// Emits 'pick' with the checked state. Not 'change': baseline's .on() adds a
// native listener for any name the element has an on-handler for, and 'pick'
// is not one, so the row reports each change once.
export const Choice = (type: 'checkbox' | 'radio', label: string | IBaseComponent<any>,
    opts: { checked: boolean, name?: string }) => {
    const base = Base('label')
    base.addClass(style.base)

    base.append(typeof label === 'string' ? Span(label) : label)

    const input = Input('', type, opts)
    input.addClass(style.input)
    base.append(input)

    const box = Span()
    box.addClass(style.box, type === 'radio' ? style.radio : style.check)
    base.append(box)

    input.on('change', ({ value }: { value: boolean }) => base.emit('pick', value))

    return base
}
